import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { SweetMessage } from '../../../config/sweet-message';
import { SessionService } from '../../../services/session.service';
import { NotaCredito } from '../../../models/nota-credito';
import { NotaCreditoDetalle } from '../../../models/nota-credito-detalle';
import { ComprobanteService } from '../../../services/comprobante.service';
import { Caja } from '../../../models/caja';
import { CajaService } from '../../../services/caja.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { VentaListModalComponent } from '../../modals/venta-list-modal/venta-list-modal.component';
import { Venta } from '../../../models/venta';
import * as moment from 'moment';
import { ParametroService } from '../../../services/parametro.service';
import { Validation } from '../../../config/validation';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { UtilsService } from '../../../services/utils.service';
import { ProveedorModalComponent } from '../../modals/proveedor-modal/proveedor-modal.component';
import { Proveedor } from '../../../models/proveedor';
import { CompraDetalle } from '../../../models/compra_detalle';
import { Compra } from '../../../models/compra';
import { CompraListModalComponent } from '../../modals/compra-list-modal/compra-list-modal.component';
import { CompraFilterModalComponent } from '../../modals/compra-filter-modal/compra-filter-modal.component';
import { CompraService } from '../../../services/compra.service';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { constructDependencies } from '@angular/core/src/di/reflective_provider';
import { CompraNotaModalComponent } from '../../modals/compra-nota-modal/compra-nota-modal.component';
import { CompraModalComponent } from '../../modals/compra-modal/compra-modal.component';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { PeriodoContable } from '../../../models/periodo-contable';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { SerieIngresoModalComponent } from '../../modals/serie-ingreso-modal/serie-ingreso-modal.component';
@Component({
	selector: 'app-nota-credito-compra-add',
	templateUrl: './nota-credito-compra-add.component.html',
	styleUrls: ['./nota-credito-compra-add.component.css'],
	providers: [
		ComprobanteService, 
		CajaService, 
		ParametroService, 
		NotaCreditoService, 
		CompraService,
		ImpuestoPorcentajeService,
		ParametroContabilidadService,
        PeriodoContableService,
	]
})
export class NotaCreditoCompraAddComponent implements OnInit {
	public nota_credito: NotaCredito;
	public notaCreditoDetalle: Array<NotaCreditoDetalle>;
	public nota_detalle: NotaCreditoDetalle;
	public caja: Caja;
	public compra: Compra;
	public cajas: Array<Caja>;
	public msgSweet: SweetMessage;
	public loading = false;
	public Mod_FactElec: string;
	public fecha_emision;
	public proveedor: Proveedor;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public numero_decimales: number;
	public venta: Venta;
	public IVA: number;
	public IVA_PARAM: number;
	FormGroup = new Array();
	iva: number;
	public vl: Validation;
	public detalle: String;
	public total_pago: number;
	public cambio: number;
	public is_numero_manual: boolean;
	public numero_documento: String;
	public fecha_actual;
	public fecha_MesAnt;
	public correos: Array<any>;
	public cantidad_excedidad:boolean;
	public parametros: Array<any>
    public iva_id : number;
    public iva_vigente:boolean;
	public iva_porcentaje : any;
	public mask: any;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;
    public parametrosContabilidad: Array<ParametroContabilidad>;
    public periodoContable: PeriodoContable;
	constructor(
		public comprobanteService: ComprobanteService,
		private ss: SessionService,
		public cajaService: CajaService,
		private modalService: BsModalService,
		private parametroService: ParametroService,
		private notaCreditoService: NotaCreditoService,
		public utils: UtilsService,
		public compraService: CompraService,
		public impuestoPorcentajeService: ImpuestoPorcentajeService,
		private parametroContabilidadService: ParametroContabilidadService,
		private periodoContableService: PeriodoContableService,
		

	) {
		this.caja = new Caja();
		this.cajas = [];
		this.correos = [];
		this.msgSweet = new SweetMessage();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.nota_credito = new NotaCredito();
		this.notaCreditoDetalle = [];
		this.fecha_emision = moment(this.fecha_emision);
		this.fecha_actual = moment(this.fecha_actual);
		this.fecha_MesAnt = moment(this.fecha_actual.subtract(1, 'months'));
		this.venta = new Venta();
		this.IVA = 0;
		this.IVA_PARAM = 0;
		this.compra = new Compra();
		this.vl = new Validation();
		this.detalle = "";
		this.proveedor = new Proveedor();
		this.nota_detalle = new NotaCreditoDetalle();
		this.total_pago = 0;
		this.cambio = 0;
		this.is_numero_manual = false;
		this.numero_decimales = 2;
		this.numero_documento = "";
		this.cantidad_excedidad = false;
		this.parametros = [];
        this.iva_id = 0;
		this.iva_vigente = false;
		this.iva_porcentaje = 0;
		this.mask = [ /[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,/\d/,/\d/,/\d/,/\d/,/\d/,];
		this.Mod_Cartera = this.ss.getData("mod_cartera");
        this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
        this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
		this.compra.fecha_emision = moment();
	}

	ngOnInit() {

		
		let p1 = this.getParametros(); 
		let p2 = this.getIVA(129);
		let p3 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p3 = this.getParametroContabilidadNotaCredito();
		}
		this.loading = true;
		this.onForm();
		Promise.all([p1,p2,p3]).then(
			res => this.loading = false,
			err => this.loading = false
		);
	}

	onForm() {
		this.FormGroup["serie"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
		this.FormGroup["punto_emision"] = { required: true, max: 3, min: 3, valid: false, n: 0 };
		this.FormGroup["secuencial"] = { required: true, min: 1, valid: false, n: 0 };
		this.FormGroup["numero_autorizacion"] = { required: true, max: 50, min: 17, valid: false, n: 0 };
		this.FormGroup["numero_documento"] = { required: true,  valid: false, n: 0,max: 17,min:7 };
		// this.FormGroup["compras"] = { required: true, valid: false, n: 0 };
		// this.FormGroup["proveedor_id"] = { required: true, valid: false, n: 0 };
		// this.FormGroup["bodega_id"] = { required: true, valid: false, n: 0 };
	}

	getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment(this.nota_credito.fecha_emision).format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
    }

    getParametroContabilidadNotaCredito(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?in[tipo]=C,P,G&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msgSweet.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
	}

	setValueAsientoContable(){
        
        let asientoContable = new AsientoContable();
        let asientoContableCobros = new AsientoContable();
        asientoContable.fecha_emision = this.nota_credito.fecha_emision;
        asientoContable.tipocomprobante = this.nota_credito.tipocomprobante;
        asientoContable.tipo_comprobante_id = this.nota_credito.tipo_comprobante_id;
        asientoContable.periodo_contable_id = this.periodoContable.id;
        asientoContable.numero_documento = this.nota_credito.numero_documento;
		asientoContable.descripcion = this.compra.proveedor.nombre_comercial;
		asientoContable.status = 'A';
        asientoContable.empresa_id = this.nota_credito.empresa_id;
        asientoContable.usuario_id = this.nota_credito.usuario_id;
        asientoContable.total = this.nota_credito.total;
        asientoContableCobros.fecha_emision = this.nota_credito.fecha_emision;
        asientoContableCobros.tipocomprobante = this.nota_credito.tipocomprobante;
        asientoContableCobros.tipo_comprobante_id = this.nota_credito.tipo_comprobante_id;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = this.nota_credito.numero_documento;
        asientoContableCobros.descripcion = this.compra.proveedor.nombre_comercial;;
        asientoContableCobros.empresa_id = this.nota_credito.empresa_id;
        asientoContableCobros.usuario_id = this.nota_credito.usuario_id;
        asientoContableCobros.total = this.nota_credito.total;
        asientoContableCobros.status = (this.nota_credito.tipo == 'CR') ? 'E':'A';
       

        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContable.empresa_id;
			asientoContableDetalle.usuario_id = asientoContable.usuario_id;
			
			if(parametroContabilidad.id == '32'){
				parametroContabilidad.tipo_saldo = "D";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.nota_credito.total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.nota_credito.total:0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				// asientoContable.detalle.push(asientoContableDetalle);   
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
					// asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);
					// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
				
			if( parametroContabilidad.id == "23") {
				parametroContabilidad.tipo_saldo = "D";
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.nota_credito.total:0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.nota_credito.total:0;
				// asientoContableCobros.detalle.push(asientoContableDetalle);
				if(parametroContabilidad.tipo_saldo == 'H'){
					// asientoContable.detalle.push(asientoContableDetalle);
					asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					// asientoContable.detalle.unshift(asientoContableDetalle);
					asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
		});
		let subtotal = 0;
        let subtotalCobro = 0;
        this.nota_credito.detalle.forEach(compraDetalle => {
			subtotal = this.utils.redondear((compraDetalle.subtotal + compraDetalle.iva),2);
			let asientoContableDetalle = new AsientoContableDetalle();
			asientoContableDetalle.empresa_id = asientoContable.empresa_id;
			asientoContableDetalle.usuario_id = asientoContable.usuario_id;
			asientoContableDetalle.cuenta_contable_id = compraDetalle.cuenta_inventario_id;
			let parametroContabilidad = this.parametrosContabilidad.filter(parametro => parametro.id == '30')[0];
			parametroContabilidad.tipo_saldo ="H";
			asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?subtotal:0;
			asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?subtotal:0;
			let cuenta = asientoContable.detalle.filter( asientoDetalle=> compraDetalle.cuenta_inventario_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_inventario_id );
			
			if( cuenta.length > 0 ) {
				let indexAsientoDetalle = asientoContable.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuenta[0].cuenta_contable_id);
				asientoContable.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_inventario_id
				asientoContable.detalle[indexAsientoDetalle].haber +=  parametroContabilidad.tipo_saldo=='H'?subtotal:0;
				asientoContable.detalle[indexAsientoDetalle].debe +=  parametroContabilidad.tipo_saldo=='D'?subtotal:0;
				
			}else if( cuenta.length == 0 && compraDetalle.cuenta_inventario_id !="0" ) {
				// asientoContable.detalle.push(asientoContableDetalle);
				if(parametroContabilidad.tipo_saldo == 'H'){
					asientoContable.detalle.push(asientoContableDetalle);
					// asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					asientoContable.detalle.unshift(asientoContableDetalle);
					// asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
			
			// subtotalCobro = Number(compraDetalle.total);
			subtotalCobro =this.utils.redondear((compraDetalle.subtotal + compraDetalle.iva),2);
			let asientoContableDetalleCobro = new AsientoContableDetalle();
			asientoContableDetalleCobro.empresa_id = asientoContableCobros.empresa_id;
            asientoContableDetalleCobro.usuario_id = asientoContableCobros.usuario_id;
			asientoContableDetalleCobro.cuenta_contable_id = compraDetalle.cuenta_costo_gasto_id;
			
			let parametroContabilidadCobro = this.parametrosContabilidad.filter(parametro => parametro.id == '29')[0];
			parametroContabilidadCobro.tipo_saldo = "H";
			asientoContableDetalleCobro.debe = parametroContabilidadCobro.tipo_saldo=='D'?subtotalCobro:0;
			asientoContableDetalleCobro.haber = parametroContabilidadCobro.tipo_saldo=='H'?subtotalCobro:0;
			
			let cuentaCobro = asientoContableCobros.detalle.filter( asientoDetalle=> compraDetalle.cuenta_costo_gasto_id!="0" && asientoDetalle.cuenta_contable_id == compraDetalle.cuenta_costo_gasto_id );
			
			if( cuentaCobro.length > 0 ) {
				let indexAsientoDetalle = asientoContableCobros.detalle.findIndex(detalle => detalle.cuenta_contable_id === cuentaCobro[0].cuenta_contable_id);
				asientoContableCobros.detalle[indexAsientoDetalle].cuenta_contable_id = compraDetalle.cuenta_costo_gasto_id
				asientoContableCobros.detalle[indexAsientoDetalle].haber +=  (parametroContabilidadCobro.tipo_saldo=='H'?subtotalCobro:0);
				asientoContableCobros.detalle[indexAsientoDetalle].debe +=  (parametroContabilidadCobro.tipo_saldo=='D'?subtotalCobro:0);
				
			}else if( cuentaCobro.length == 0 && compraDetalle.cuenta_costo_gasto_id !="0" ) {
				// asientoContableCobros.detalle.unshift(asientoContableDetalleCobro);
				if(parametroContabilidad.tipo_saldo == 'H'){
					// asientoContable.detalle.push(asientoContableDetalle);
					asientoContableCobros.detalle.push(asientoContableDetalle);
				}else{
					// asientoContable.detalle.unshift(asientoContableDetalle);
					asientoContableCobros.detalle.unshift(asientoContableDetalle);   
				}     
			}
		});
		this.nota_credito.asientosContables.push(asientoContable);
		this.nota_credito.asientosContables.push(asientoContableCobros);
    }

	getNumeroDocumento(event){
		let numero_documento = event.target.value;
		
		this.nota_credito.serie = numero_documento.split('-')[0];
		this.nota_credito.punto_emision = numero_documento.split('-')[1];
		this.nota_credito.secuencial = numero_documento.split('-')[2];
		
	}

	// --------- GET IVA ----------
	
	getIVA(id) {
		return new Promise((resolve, reject) => {

			this.impuestoPorcentajeService.getById(id).subscribe(
				res => {
					this.iva_porcentaje = (res.porcentaje*100)/100;
					this.IVA = parseFloat(this.iva_porcentaje) / 100;
					this.IVA_PARAM = this.iva_porcentaje;
					this.calcularTotal();
					resolve();
				},
				err => {
					this.iva_porcentaje = 0;
					this.IVA = 0;
					this.IVA_PARAM= 0;
					reject(err);
				}
			);

			
		});
	}

	getParametros() {
		return new Promise((resolve, reject) => {
			let qs ="?impuesto_id=2&is_tarifa=1&is_vigente=1&is_comprobante=1";
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.parametros = res.data;
					this.iva_id = this.parametros[0].id;
					resolve();
				},
				err => {
					this.parametros = [];
					reject(err);
				}
			);

		});
	}

	onChangeIva(id) {
		this.loading = true;

		this.getIVA(id).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}


	// ------------ Get Subtotal ----------------------
	getSubtotal(compra) {
		return parseFloat(compra.subtotal_iva12) + parseFloat(compra.subtotal_iva0);
	}

	// -------- setNCElectronica ----------
	setNCElectronica() {
		let NcElectronica = {};
		NcElectronica['datos'] = {};
		NcElectronica['datos']['infoTributaria'] = {};
		NcElectronica['datos']['infoTributaria']['ambiente'] = "";
		NcElectronica['datos']['infoTributaria']['tipoEmision'] = 1;
		NcElectronica['datos']['infoTributaria']['razonSocial'] = "";
		NcElectronica['datos']['infoTributaria']['ruc'] = this.ss.getData('emp_ruc');
		NcElectronica['datos']['infoTributaria']['claveAcceso'] = "";
		NcElectronica['datos']['infoTributaria']['codDoc'] = "04"; //Nota de Crédito
		NcElectronica['datos']['infoTributaria']['estab'] = this.nota_credito.serie;
		NcElectronica['datos']['infoTributaria']['ptoEmi'] = this.nota_credito.punto_emision;
		NcElectronica['datos']['infoTributaria']['secuencial'] = this.nota_credito.secuencial.toString().padStart(9, "0");
		NcElectronica['datos']['infoTributaria']['dirMatriz'] = "";

		NcElectronica['datos']['infoNotaCredito'] = {};
		NcElectronica['datos']['infoNotaCredito']['fechaEmision'] = moment(this.nota_credito.fecha_emision).format("DD/MM/YYYY");
		NcElectronica['datos']['infoNotaCredito']['dirEstablecimiento'] = "";
		NcElectronica['datos']['infoNotaCredito']['tipoIdentificacionComprador'] = this.venta.cliente.tipoidentificacion.cod_dni;
		NcElectronica['datos']['infoNotaCredito']['razonSocialComprador'] = this.venta.cliente.razon_social;
		NcElectronica['datos']['infoNotaCredito']['identificacionComprador'] = this.venta.cliente.dni;
		if (this.venta.cliente.es_contribuyente) {
			NcElectronica['datos']['infoNotaCredito']['contribuyenteEspecial'] = this.venta.cliente.num_contribuyente;
		}
		NcElectronica['datos']['infoNotaCredito']['obligadoContabilidad'] = (this.venta.cliente.es_obligado == true ? "SI" : "NO");
		NcElectronica['datos']['infoNotaCredito']['codDocModificado'] = "01"; //FACTURA
		NcElectronica['datos']['infoNotaCredito']['numDocModificado'] = this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial.toString().padStart(9, "0");
		NcElectronica['datos']['infoNotaCredito']['fechaEmisionDocSustento'] = moment(this.venta.fecha_emision).format("DD/MM/YYYY");
		NcElectronica['datos']['infoNotaCredito']['totalSinImpuestos'] = (this.nota_credito.subtotal_iva12 + this.nota_credito.subtotal_iva0);
		NcElectronica['datos']['infoNotaCredito']['valorModificacion'] = this.nota_credito.total;
		NcElectronica['datos']['infoNotaCredito']['moneda'] = "DOLAR";

		NcElectronica['datos']['infoNotaCredito']['totalConImpuestos'] = [];
		if (this.nota_credito.subtotal_iva0 > 0) {
			let totalConImpuestos = {};
			totalConImpuestos['codigo'] = 2;
			totalConImpuestos['codigoPorcentaje'] = 0;
			totalConImpuestos['baseImponible'] = this.nota_credito.subtotal_iva0;
			totalConImpuestos['valor'] = "0.00";

			NcElectronica['datos']['infoNotaCredito']['totalConImpuestos'].push(totalConImpuestos);
		}

		if (this.nota_credito.subtotal_iva12 > 0) {
			let totalConImpuestos = {};
			totalConImpuestos['codigo'] = 2;
			totalConImpuestos['codigoPorcentaje'] = 2;
			totalConImpuestos['baseImponible'] = this.nota_credito.subtotal_iva12;
			totalConImpuestos['valor'] = this.nota_credito.iva;

			NcElectronica['datos']['infoNotaCredito']['totalConImpuestos'].push(totalConImpuestos);
		}

		NcElectronica['datos']['infoNotaCredito']['motivo'] = this.nota_credito.motivo;

		NcElectronica['datos']['detalles'] = [];
		this.nota_credito.detalle.forEach((item) => {
			let detalle = {};
			let detalle_item = item.detalle.toString().replace(/\n/g, ", ");

			detalle['codigoInterno'] = (item.producto.codigo).replace(/\//g, '-');
			detalle['codigoAdicional'] = (item.producto.codigo).replace(/\//g, '-');
			detalle['descripcion'] = (item.producto.nombre + (item.detalle.length > 0 ? " - " + detalle_item : "")).replace(/\//g, '-');
			detalle['cantidad'] = item.cantidad;
			detalle['precioUnitario'] = item.precio_unitario;
			detalle['descuento'] = 0;
			detalle['precioTotalSinImpuesto'] = item.subtotal;
			/*detalle['detallesAdicionales'] = [];
			let detAdicional = {};*/

			detalle['impuestos'] = [];
			let impuesto = {};
			impuesto['codigo'] = 2;
			impuesto['codigoPorcentaje'] = (item.iva > 0 ? 2 : 0);
			impuesto['tarifa'] = (item.iva > 0 ? 12 : 0);
			impuesto['baseImponible'] = item.subtotal;
			impuesto['valor'] = Math.round(item.iva * 100) / 100;
			detalle['impuestos'].push(impuesto);
			NcElectronica['datos']['detalles'].push(detalle);
		});

		NcElectronica['datos']['infoAdicional'] = [];
		let adicional = {};
		adicional['Email'] = this.correos.toString();// this.venta.cliente.correo;
		adicional['Direccion'] = this.venta.cliente.direccion.replace(/\//g, '-');

		let telefono = "0999999999";
		if (this.venta.cliente.telefono.toString().trim().length > 0) {
			telefono = this.venta.cliente.telefono.toString();
		}
		if (this.venta.cliente.celular.toString().trim().length > 0) {
			telefono = this.venta.cliente.celular.toString();
		}
		adicional['Telefono'] = telefono;

		NcElectronica['datos']['infoAdicional'].push(adicional);

		return NcElectronica;
	}
	// -------------- setValueEntity -------------
	setValueEntity() {
		this.nota_credito.is_secuencial_manual = this.is_numero_manual;
		if (this.is_numero_manual) this.nota_credito.numero_documento = this.numero_documento;
		this.nota_credito.tipo = "C";
		if(this.Mod_FactElec){
			this.nota_credito.tipo_comprobante_id="9";
        }
        else{
            this.nota_credito.tipo_comprobante_id="8";
        }
		 
		this.nota_credito.fecha_emision = moment(this.fecha_emision).format("YYYY-MM-DD")
		this.nota_credito.documento_id = this.compra.id;

		this.notaCreditoDetalle.forEach(detalle => {
			detalle.producto_id = detalle.producto.id;
			detalle.cuenta_ingreso_id = detalle.producto.cuenta_ingreso_id;
			detalle.cuenta_inventario_id = detalle.producto.cuenta_inventario_id;
			detalle.cuenta_costo_gasto_id = detalle.producto.cuenta_costo_gasto_id;
			
			if (parseInt(this.compra.tipo_comprobante_id.toString()) === 1  || parseInt(this.compra.tipo_comprobante_id.toString()) === 4) {

				if (!detalle.producto.graba_iva) {
					detalle.iva = 0;
				} else {
					detalle.iva = detalle.subtotal * this.IVA;
				}
			} else {
				detalle.iva = 0;
			}
			detalle.total = detalle.subtotal + detalle.iva;
		});

		this.nota_credito.detalle = this.notaCreditoDetalle;
		
		this.nota_credito.numero_documento = this.nota_credito.serie +"-"+  this.nota_credito.punto_emision  +"-"+ this.compra.secuencial;
		this.nota_credito.usuario_id = this.ss.getData('usuario_id');
		this.nota_credito.empresa_id = this.ss.getData('empresa_id');
		this.nota_credito.sucursal_id = this.ss.getData('sucursal_id');
	}


	// ---------------- ON SUBMIT ---------------- 
	onSubmit() {

		// this.bsModalRef2.hide();
		let preg = "¿Está seguro de confirmar el documento?";
		const initialState = { Pregunta: preg, Respuesta: false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, { initialState }));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if (Respuesta == true) {
				this.setValueEntity();

				

				if (this.Mod_FactElec) {
					if (this.venta.cliente.es_contribuyente) {
						if (this.venta.cliente.num_contribuyente.toString().trim().length === 0) {
							this.msgSweet.showMessage('error-message', "El cliente no consta con número de contribuyente");
							return false;
						}
					}
					this.nota_credito.json_string = this.setNCElectronica();
				}

				if( this.Mod_Cartera && this.Mod_Contabilidad ){

					this.getPeriodoActual().then(
						res => {
							this.setValueAsientoContable();
							   this.saveNotaCredito();     
						}
					);
				}else {
				   this.saveNotaCredito();   
				}

				

			}
		});


	}

	saveNotaCredito(){
		this.loading = true;
		this.notaCreditoService.save(this.nota_credito).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.nota_credito = new NotaCredito();
				this.notaCreditoDetalle = [];
				this.nota_detalle = new NotaCreditoDetalle();
				this.compra = new Compra();
				this.numero_documento = "";
				this.cambio = 0;
				this.total_pago = 0;
			},
			err => {
				this.loading = false;
				this.msgSweet.showMessage('error-message', err);
			}
		);
	}

	// ------- DIALOG PROVEEDOR --------------- 
	openDialogProveedor() {
		const initialState = {};
		this.bsModalRef = this.modalService.show(ProveedorModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendProveedor.take(1).subscribe((value) => {
			this.sendObjectProveedor(value);
		});
	}

	sendObjectProveedor(event) {
		//obtencion del producto que envia el componente producto-modal
		this.proveedor = event;
		
	}

	sendObjectProducto(producto: any) {
		let temp = this.notaCreditoDetalle.find(x => x.producto_id == producto.id);

		if (!temp) {
			let notaCreditoDetalle = new NotaCreditoDetalle();
			notaCreditoDetalle.producto = producto;
			notaCreditoDetalle.precio_unitario = parseFloat(producto.precio);
			notaCreditoDetalle.subtotal = notaCreditoDetalle.cantidad * notaCreditoDetalle.precio_unitario;

			if (parseInt(this.compra.tipo_comprobante_id.toString()) === 1 || parseInt(this.compra.tipo_comprobante_id.toString()) === 4) {
				if (producto.graba_iva === 0) {
					notaCreditoDetalle.iva = 0;
					notaCreditoDetalle.porct_iva = 0;
				} else {
					notaCreditoDetalle.iva = notaCreditoDetalle.subtotal * this.IVA;
					notaCreditoDetalle.porct_iva = this.IVA_PARAM;
				}
			} else {
				notaCreditoDetalle.iva = 0;
				notaCreditoDetalle.porct_iva = 0;
			}
			notaCreditoDetalle.total = notaCreditoDetalle.subtotal + notaCreditoDetalle.iva;
			notaCreditoDetalle.usuario_id = this.ss.getData('usuario_id');
			notaCreditoDetalle.empresa_id = this.ss.getData('empresa_id');
			notaCreditoDetalle.sucursal_id = this.ss.getData('sucursal_id');

			this.notaCreditoDetalle.push(notaCreditoDetalle);
			this.calcularTotal();
		}

	}


	// ---------- VALIDAR INPUTS---------------
	onkeyUp(event, campo) {
		if (this.FormGroup[campo].n == 0) {
			if (event.target.value.length > 0) {
				this.FormGroup[campo].n = 1;
			}
		}
	}

	calcularItem(precio_unitario: number, compra_detalle: CompraDetalle) {
		compra_detalle.precio_unitario = precio_unitario;
		compra_detalle.subtotal = compra_detalle.precio_unitario * compra_detalle.cantidad;
		compra_detalle.iva = compra_detalle.subtotal * this.iva;
		compra_detalle.total = compra_detalle.subtotal + compra_detalle.iva;
		//this.calcularFactura();
	}

	onSearch() {
		let qs = "";//"&embed=retencion";
		const initialState = { qs };
		this.bsModalRef = this.modalService.show(CompraNotaModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.onSelectedRow.take(1).subscribe(compra => {
			// this.compra = compra;
			this.getDataCompra(compra);
			
		});
	}

	getDataCompra(compra){
		this.compraService.getById(compra.id, "?embed=proveedor?embed=tipoidentificacion,bodega,cliente,guiaremision,retencion,detalle?embed=producto").subscribe(res=>{
			this.compra = res.data; 
			
			this.notaCreditoDetalle = [];
			this.compra.detalle.forEach(item => {
				let detalle = new NotaCreditoDetalle();
				detalle.cantidad = item.cantidad;
				detalle.cantidad_original = item.cantidad;
				detalle.precio_unitario = parseFloat(item.precio_unitario.toString());
				detalle.producto = item.producto;
				detalle.detalle = item.detalle;
				//detalle.producto.unidadmedida.nombre = item.unidad;
				//detalle.producto. TODO: falta cantidad stock
				// detalle.desc_porcent = parseFloat(item..toString());
				detalle.desc_valor = parseFloat(item.desc_valor.toString());
				detalle.subtotal = parseFloat(item.subtotal.toString());
				//item.precio_unitario
				detalle.usuario_id = this.ss.getData('usuario_id');
				detalle.empresa_id = this.ss.getData('empresa_id');
				detalle.sucursal_id = this.ss.getData('sucursal_id');

				this.notaCreditoDetalle.push(detalle);
			});
			this.calcularTotal();
			
			// if( this.compra.proveedor.correo.trim().length ){
			// 	this.correos = this.compra.proveedor.correo.split(',');
			// }
			
		},err=>{

		});
		
	}

	// ---------- CALCULAR TOTAL ----------
	calcularTotal() {
		this.nota_credito.subtotal_iva12 = 0;
		this.nota_credito.subtotal_iva0 = 0;
		this.nota_credito.iva = 0;
		this.nota_credito.total = 0;
		let tipo_comprobante_id = parseInt(this.compra.tipo_comprobante_id.toString());

		this.notaCreditoDetalle.forEach(obj => {
			if ((tipo_comprobante_id === 1 && obj.producto.graba_iva) || tipo_comprobante_id === 4 && obj.producto.graba_iva) {
				this.nota_credito.subtotal_iva12 += parseFloat(obj.subtotal.toString());
			} else {
				this.nota_credito.subtotal_iva0 += parseFloat(obj.subtotal.toString());
			}
		});

		if (tipo_comprobante_id === 1 || tipo_comprobante_id === 4) {
			this.nota_credito.iva = Math.round((this.nota_credito.subtotal_iva12 * this.IVA) * 100) / 100;
		} else {
			this.nota_credito.iva = Math.round(this.nota_credito.subtotal_iva12 * 100) / 100;
		}

		this.nota_credito.subtotal = parseFloat(this.nota_credito.subtotal_iva0.toString()) + parseFloat(this.nota_credito.subtotal_iva12.toString());
		this.nota_credito.total = parseFloat(this.nota_credito.subtotal.toString()) + parseFloat(this.nota_credito.iva.toString());

		//Recalcular cambio
		this.total_pago = 0;
		this.cambio = (this.total_pago > this.nota_credito.total ? (this.total_pago - this.compra.total) : 0);
		this.cambio = Math.round(this.cambio * 100) / 100;
	}

	// ----------OPEN MODAL DETALLE ------------------

	openModalDetalle(template: TemplateRef<any>, nota_detalle) {
		this.detalle = nota_detalle.detalle;
		this.nota_detalle = nota_detalle;
		this.bsModalRef = this.modalService.show(template);
	}

	// ---------ADD DETALLE ---------------
	add(detalle) {
		if (detalle.cantidad < detalle.cantidad_original) {
			detalle.cantidad++;

			detalle.subtotal = detalle.cantidad * detalle.precio_unitario;

			this.calcularTotal();
		}
	}
	// ---------- SUB DETALLE -------------------
	sub(detalle) {
		if (detalle.cantidad > 1) {
			detalle.cantidad--;

			detalle.subtotal = detalle.cantidad * detalle.precio_unitario;

			this.calcularTotal();
		}
	}
	// ------------ VERIFICATION VALUE  ----------------------
	verificationValue(event, notaCreditoDetalle:  NotaCreditoDetalle, campo: string) {
		this.cantidad_excedidad = false;
		this.notaCreditoDetalle.forEach(nc=>{
			if(nc.cantidad > nc.cantidad_original){
				
				this.msgSweet.showMessage('error-message', "La cantidad no puede ser mayor a la de la factura de compra");
				this.cantidad_excedidad= true;
			}
		});
		
		if (event.target.value.trim().length === 0) {
			if (campo === 'cantidad') {
				notaCreditoDetalle[campo] = 1;
			} else {
				notaCreditoDetalle[campo] = 0;
			}
		}
	}

	// ----------- CHANGE VALUE --------------
	changeValue(event, notaCreditoDetalle: NotaCreditoDetalle, campo: string) {
		notaCreditoDetalle[campo] = event.target.value;
		notaCreditoDetalle.subtotal = notaCreditoDetalle.cantidad * notaCreditoDetalle.precio_unitario;


		let valor = this.utils.redondear((notaCreditoDetalle.cantidad * notaCreditoDetalle.precio_unitario), 2);
		let subtotal = valor - notaCreditoDetalle.desc_valor;
		//let porcent_value = subtotal * (notaCreditoDetalle.desc_porcent / 100)
		notaCreditoDetalle.subtotal = subtotal;


		this.calcularTotal();
	}

	// --------- DELETE ------------

	onDelete(i) {
		this.notaCreditoDetalle.splice(i, 1);
		this.calcularTotal();
	}

	// ---------- IS VALID FORM ------------
	isValidForm() {
		if (this.nota_credito.motivo.trim().length < 1) {
			return false;
		}

		if (!this.nota_credito.numero_autorizacion) {
			return false;
		}

		if (this.nota_credito.serie == undefined || this.compra.serie.toString().trim().length === 0) {
			return false;
		}
		if (this.nota_credito.punto_emision == undefined || this.compra.punto_emision.toString().trim().length === 0 ) {
			return false;
		}
		if (this.nota_credito.secuencial == undefined || this.nota_credito.secuencial.toString().trim().length === 0) {
			return false;
		}

		// if (this.fecha_emision < this.fecha_MesAnt) {
		// 	return false;
		// }

		// if( !this.nota_credito.tipo_comprobante_id ){
		// 	return false;
		// }

		// if( !this.compra.id ){
		// 	return false;
		// }
		if( this.notaCreditoDetalle.length < 1 ){
			return false;
		}

		let b = false;
		this.notaCreditoDetalle.forEach(item => {
			if (item.cantidad < 1 || item.precio_unitario == 0 ) {
				b = true;
			}
		});
		if (b) {
			return false;
		}

		if (this.cantidad_excedidad) {
			return false;
		}


		if (this.nota_credito.numero_documento.toString().trim().length === 0) {
			return false;
		}

		return true;
	}



	// ----------- SAVE DETALLE -------------
	saveDetalle() {
		this.nota_detalle.detalle = this.detalle.toString().trim();
		this.detalle = "";
		this.bsModalRef.hide();
	}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/nota-credito-compra-add/nota-credito-compra-add.component.ts